import React from "react";
import { Link } from "react-router-dom";
import { Pagination } from "./Pagination";
import { Collapse } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import BucketSearch from "../bucket/BucketSearch";
import { SearchResultsItem } from "./SearchResultsItem";
import { RelatedObjectSubItem } from "../detail/RelatedObjectSubItem";
import { StoreContext } from "../../contexts/StoreContext";

import "../../scss/pages/_detail-view-page.scss";

@inject("searchStore", "detailViewStore", "previewStore", "popupStore")
@observer
export class ExactMatchSearchItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openMemberPanel: this.props.openMemberPanel,
      exactSearchResults: {},
      exactSearchCurrentPage: 1,
      exactSearchPerPage: this.props.exactSearchPerPage || 10,
      searchMemberExpression: "",
      framework: this.props.framework,
    };
  }

  setExactSearchCurrentPage = (value) => {
    this.setState({ exactSearchCurrentPage: value });
  };
  setExactSearchPerPage = (value) => {
    this.setState({ exactSearchPerPage: value }, () => {
      this.fetchExactMatchSearchLookup(); // force fetching data here because state is not updated before fetching from the pagination component
    });
  };
  setSearchMemberExpression = (type, value) => {
    this.setState({ searchMemberExpression: value });
  };

  fetchExactMatchSearchLookup = async () => {
    const { fetchExactMatchSearchLookupState } = this.props.searchStore;
    const response = await fetchExactMatchSearchLookupState(
      this.props.item,
      this.state,
      this.props.framework
    );
    if (
      JSON.stringify(this.state.exactSearchResults.navigationLookupBuckets) !==
      JSON.stringify(response.navigationLookupBuckets)
    ) {
      this.setState({ exactSearchResults: response });
    }
  };

  componentDidMount() {
    this.fetchExactMatchSearchLookup();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.framework?.tid !== this.props.framework?.tid) {
      this.fetchExactMatchSearchLookup();
    }

    const openMemberPanel = this.state.openMemberPanel;
    const exactSearchResults = this.state.exactSearchResults;
    const searchMemberExpression = this.state.searchMemberExpression;
    if (
      prevState.openMemberPanel !== openMemberPanel ||
      (prevState.exactSearchResults === exactSearchResults &&
        prevState.searchMemberExpression === searchMemberExpression)
    ) {
      return;
    }
  }

  renderItems = (items) => {
    return items.length ? (
      <div className="item-list-container">
        {items.map((item, key) => (
          <div style={{ margin: "4px 0", padding: "3px 0" }} key={key}>
            <RelatedObjectSubItem item={item} />
          </div>
        ))}
      </div>
    ) : (
      "Nothing found"
    );
  };

  handleCollapse = () => {
    this.setState({
      openMemberPanel: !this.state.openMemberPanel,
    });
  };

  getVariableDomain = (item) => {
    if (item && item.object && item.object.type === "Domain") {
      return item.object;
    }
    if (item && item.items && item.items.length > 0) {
      return this.getVariableDomain(item.items[0]);
    }
  };

  renderMemberList = () => {
    if (this.context === this.props.popupStore) return <></>;
    const { item } = this.props;

    const membersBucket =
      this.state.exactSearchResults &&
      this.state.exactSearchResults.navigationLookupBuckets &&
      this.state.exactSearchResults.navigationLookupBuckets["Members"];
    const total = membersBucket && membersBucket.totalCountOfObjects;
    const currentPage = this.state.exactSearchCurrentPage;
    const perPage = this.state.exactSearchPerPage;

    const fetchExactMatchSearchLookupUpdateState = async (item) => {
      const { fetchExactMatchSearchLookupState } = this.props.searchStore;
      const response = await fetchExactMatchSearchLookupState(
        item,
        this.state,
        this.props.framework
      );
      this.setState({ exactSearchResults: response });
    };

    const exportVariableMembers = (
      <div
        className="custom-export-alignament"
        onClick={() =>
          this.props.detailViewStore.exportVariableMembers(
            { object: item },
            true,
            this.props.framework
          )
        }
      >
        <h5>Excel export</h5>
        <span
          className="glyphicon glyphicon-download-alt"
          style={{ float: "right", cursor: "pointer" }}
        />
      </div>
    );

    return (
      <div
        style={{ marginTop: "20px" }}
        className="custom-panel related-types-list"
      >
        <div className="custom-panel bucket-search">
          <div className="custom-panel-heading">
            <h5 onClick={this.handleCollapse}>Members (allowed values)</h5>
            {exportVariableMembers}
          </div>
          <Collapse in={this.state.openMemberPanel}>
            <div className="custom-panel-body related-types-list">
              {this.props.children}
              <React.Fragment>
                <div className="bucket-pagination-container">
                  <BucketSearch
                    getSearchExpression={this.state.searchMemberExpression}
                    setSearchExpression={this.setSearchMemberExpression}
                    fetchSearchResults={() =>
                      fetchExactMatchSearchLookupUpdateState(item)
                    }
                    setCurrentPage={this.setExactSearchCurrentPage}
                    type={"Members"}
                  />
                  <Pagination
                    fetchSearchResults={() =>
                      fetchExactMatchSearchLookupUpdateState(item)
                    }
                    setCurrentPage={this.setExactSearchCurrentPage}
                    setPerPage={this.setExactSearchPerPage}
                    perPage={this.state.exactSearchPerPage}
                    currentPage={this.state.exactSearchCurrentPage}
                    searchQuery={this.state.searchMemberExpression}
                    totalResults={total}
                  />
                </div>

                {total ? (
                  <p>
                    <em>
                      {`Showing ${
                        currentPage === 1 ? 1 : (currentPage - 1) * perPage + 1
                      } - ${
                        total < perPage || currentPage * perPage > total
                          ? total
                          : currentPage * perPage
                      } of ${total} results`}
                    </em>
                  </p>
                ) : (
                  ""
                )}

                {membersBucket && this.renderItems(membersBucket.objects)}
              </React.Fragment>
            </div>
          </Collapse>
        </div>
      </div>
    );
  };

  renderDomainInfo = (domain) => {
    const tid = domain && domain.tid;
    const name = domain && domain.name;
    return (
      <div>
        Domain:{" "}
        <Link to={`/view/Domain/${tid}`} target={"_blank"}>
          {name}
        </Link>
      </div>
    );
  };
  static contextType = StoreContext;
  render() {
    const { item, key, hideDetails } = this.props;
    const domainsBucket =
      this.state.exactSearchResults &&
      this.state.exactSearchResults.navigationLookupBuckets &&
      this.state.exactSearchResults.navigationLookupBuckets["Domains"];
    const domainObject =
      domainsBucket && domainsBucket.objects && domainsBucket.objects[0];
    return (
      <div>
        {!hideDetails && <SearchResultsItem {...item} key={key} />}
        <div
          style={{
            margin: hideDetails ? "0 0 0px 0" : " 0 0 20px 20px",
          }}
        >
          {(domainObject && domainObject.isEnumerated) || this.props.framework
            ? this.renderMemberList()
            : this.renderDomainInfo(domainObject)}
        </div>
      </div>
    );
  }
}
